import {
  BREAKDOWN_SET_DATA,
  BREAKDOWN_SET_FILTER,
  BREAKDOWN_SET_LOADING,
} from "../actions/breakdown.actions";
import dayjs from "dayjs";
import { INITIALIZE_STORE } from "../actions/manager.actions";

const initialState = {
  filter: {
    date: dayjs().format("YYYY-MM-DD"),
    position: [],
    playerGroups: [],
    session: null,
    drills: [],
  },
  loading: false,
  data: null,
};

export const breakdownReducer = (state = initialState, action) => {
  switch (action.type) {
    case BREAKDOWN_SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case BREAKDOWN_SET_DATA:
      return {
        ...state,
        data: action.payload,
      };
    case BREAKDOWN_SET_FILTER:
      return {
        ...state,
        filter: { ...state.filter, ...action.payload },
      };
    case INITIALIZE_STORE:
      return initialState;
    default:
      return state;
  }
};
